import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Button, withStyles, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import * as downloadDataReducers from '../reducer/DownloadDataSelectReducers';
import * as downloadDataActionMgr from '../action-mgr';
import * as strings from '../../helpers/strings';
import '../../index.css';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import FolderIcon from '@material-ui/icons/Folder'; 
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';

class RequestDataTable extends Component {
  constructor() {
    super();
    this.state = {
      checked: [],
      expanded: [],
      showDialog: false,
      isDownloadDisabled: true, 
      selectedFileNames: [],
    };
  }

  extractFileName = (filePath) => {
    const pathParts = filePath.split('/');
    return pathParts[pathParts.length - 1];
  };

  handleCheck = (checked) => {
    const isDownloadDisabled = checked.length === 0;
    const selectedFileNames = checked.map((file) => this.extractFileName(file));
    this.setState({ checked, isDownloadDisabled, selectedFileNames });
  };

  handleExpand = (expanded) => {
    this.setState({ expanded });
  };

  handleDownload = () => {
    const { generateDownloadDataLink } = this.props;
    const { checked } = this.state;

    // Get the list of selected files
    const selectedFiles = checked.filter((file) => file.endsWith('.txt'));

    // Make API call to get download links (handled in the action)
    generateDownloadDataLink({ fileList: selectedFiles });
  };

  handleDialogClose = () => {
    // Close the dialog box
    this.setState({
      showDialog: false,
    });
  };

  render() {
    const { downloadDataObject } = this.props;
    if (!downloadDataObject.downloadDataList) {
      return <div>Please submit your request to generate the data download link.</div>;
    }

    const downloadDataList = downloadDataObject.downloadDataList;
    const { years } = downloadDataList;

    // Convert your data to a format expected by CheckboxTree
    const treeData = years.map((yearData) => ({
      value: yearData.year,
      label: `${strings.lblYear}: ${yearData.year}`,
      children: yearData.months.map((monthData) => ({
        value: `${yearData.year}-${monthData.month}`,
        label: `${strings.lblMonth}: ${monthData.month}`,
        children: monthData.files
          .filter((fileData) => fileData.fileName.endsWith('.txt')) // Update to fileData.fileName
          .map((fileData) => ({
            value: fileData.fileName,
            label: (
              <div className='treeDataField'>
                <span className='fileName'>{this.extractFileName(fileData.fileName)}</span>
                <span className='fileSize'>{fileData.fileSize}</span>
                <span className='lastModified'>{fileData.lastModified}</span>
              </div>
            ),
            icon: <DescriptionTwoToneIcon color="primary" />, // Use Description icon for leaf nodes (files)
            fileSize: fileData.fileSize,
            lastModified: fileData.lastModified,
          })),
      })),
    }));
    

    return (
      <Paper className="downloadDataResult">
        <ul className="downloadDataList">
          <li className="downloadDataHeader">
            <span> {strings.lblDownloadDataList} </span>
            <span> {strings.lblFileSize} </span>
            <span> {strings.lblLastModified} </span>
            {/* {this.state.selectedFileNames.length > 0 && (
                <span>  {strings.lblSelectedFileList} </span>
            )} */}
          </li>
        </ul>
        <div className="downloadDataListDiv">
          <CheckboxTree
          className= "checkboxTreeCheck"
            nodes={treeData}
            checked={this.state.checked}
            expanded={this.state.expanded}
            onCheck={this.handleCheck}
            onExpand={this.handleExpand}
            icons={{
              check: <CheckBoxIcon color="primary" />,
              uncheck: <CheckBoxOutlineBlankIcon color="primary" />,
              halfCheck: <IndeterminateCheckBoxIcon color="primary" />,
              expandClose: <AddIcon color="primary" />,
              expandOpen: <RemoveIcon color="primary" />,
              parentClose: <FolderIcon color="primary" />, // Set the Folder icon for closed parent nodes
              parentOpen: <FolderIcon color="primary" />, // Set the Folder icon for open parent nodes
            }}
          />
        {/* <div className='selectedFileListDiv'>

          {this.state.selectedFileNames.map((fileName) => (
            <div key={fileName}>{fileName}</div>
          ))}
        </div> */}

        </div>
        <div className='downloadDataDownload'>
          <Button
            variant={strings.btnRaised}
            color={strings.colorPrimary}
            onClick={this.handleDownload}
            disabled={this.state.isDownloadDisabled}
          >
            {strings.lblDownload}
          </Button>
        </div>
        {/* Dialog box for exceeding 4 months */}
        <Dialog open={this.state.showDialog} onClose={this.handleDialogClose}>
          <DialogTitle>{strings.lblErrorReports}</DialogTitle>
          <DialogContent>
            <p>Only 4 months at a time can be downloaded. Please select up to 4 months.</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  downloadDataObject: downloadDataReducers.listDownloadDataObject(state),

  selectedMonth: downloadDataReducers.getSelectedMonth(state),
  selectedYear: downloadDataReducers.getSelectedYear(state),
  selectedStation: downloadDataReducers.getSelectedStationName(state),
});

const mapActionsToProps = {
  generateDownloadDataLink: downloadDataActionMgr.callGenerateDownloadDataLinkApi,
};

export default connect(mapStateToProps, mapActionsToProps)((RequestDataTable));
